import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { CdsIconConfig } from '@cds/ng-core/icon';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { CdsIconModule } from '@cds/ng-web-components/icon';

@Component({
  selector: 'app-cd-accordion-panel-tpl',
  templateUrl: './cd-accordion-panel-tpl.component.html',
  styleUrls: ['./cd-accordion-panel-tpl.component.scss'],
  animations: [
    trigger('openClose', [
      state(
        'detail-expaned',
        style({
          height: '*',
          paddingTop: 'var(--cds-spacing-03)',
          paddingBottom: 'var(--cds-spacing-04)',
          opacity: '1',
        })
      ),
      state(
        'detail-collapsed',
        style({
          height: '0px',
          overflow: 'hidden',
          opacity: '0',
        })
      ),
      transition('detail-expaned <=> detail-collapsed', [animate('0.3s ease-in-out')]),
    ]),
  ],
  imports: [NgClass, CdsIconModule, NgTemplateOutlet],
})
export class CdAccordionPanelTplComponent implements OnInit {
  constructor() {}

  @Input() headerTpl?: TemplateRef<unknown>;
  @Input() upIcon = 'action:button_down_outlined';
  @Input() downIcon = 'action:button_down_filled';
  @Input() color = '#EC6453';
  @Input() mouseColor = '#D03A39';
  @Input() size = '20px';
  @Input() borderStyle = false;

  _config: CdsIconConfig = {
    color: this.color,
  };
  _iconClass = 'collapsed';
  _detaiClass = 'detail-collapsed';
  _expand? = false;
  borderClass = '';
  borderNone = '';

  ngOnInit(): void {
    if (this.borderStyle) {
      this.borderClass = 'border-class';
      this.borderNone = 'border-none';
    }
  }

  mouseenterFun() {
    this.size = '24px';
    this._config = {
      color: this.mouseColor,
    };
  }
  mouseleaveFun() {
    this.size = '20px';
    this._config = {
      color: this.color,
    };
  }

  @Input()
  set expand(val: boolean | undefined) {
    this._expand = !!val;
    this._detaiClass = this.expand ? 'detail-expaned' : 'detail-collapsed';
    this._iconClass = this.expand ? 'expanded' : 'collapsed';
  }

  get expand() {
    return this._expand;
  }

  trigger() {
    this.expand = !this.expand;
  }
}
